import * as React from 'react'

import { Label, SubText, Text } from '@procurify/ui'

import { UserAvatar } from '@webapp/components/UserAvatar'
import { type UserLike } from '@webapp/core/interfaces/components/UserLike'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { UserLabelStyled } from './styles/UserLabelStyled'
import { type IWithUserTooltipProps, WithUserTooltip } from '../WithUserTooltip'

export interface IUserLabelProps {
  user: UserLike
  WithUserTooltipProps?: Partial<IWithUserTooltipProps>
  showDelegatee?: boolean
  fluid?: boolean
}

export const UserLabel = ({
  user,
  WithUserTooltipProps,
  showDelegatee = false,
  fluid = false,
}: IUserLabelProps) => {
  const intl = useProcurifyIntl()

  return user ? (
    <WithUserTooltip {...WithUserTooltipProps} user={user} open>
      <UserLabelStyled>
        <Label
          fluid={fluid}
          component={
            <UserAvatar
              shadow={false}
              url={user.profileImage ?? undefined}
              size='xsmall'
              circular
            />
          }
        >
          <Text bold={false} autoMargin={false}>
            {user.fullName}
          </Text>
          {showDelegatee && user.approvalDelegatee && (
            <SubText bold={false} autoMargin={false} color='textSecondary'>
              {intl.formatMessage(messages.delegatedToLabel, {
                delegateeFullName: user.approvalDelegatee.fullName,
              })}
            </SubText>
          )}
        </Label>
      </UserLabelStyled>
    </WithUserTooltip>
  ) : null
}
